import React, { useState, useEffect } from "react";
import jsPDF from "jspdf";
import { toWords } from "number-to-words";
import "./CreateOrder.css";
import html2canvas from "html2canvas";
import OrderPdfTemplate from "./OrderPdfTemplate";
import { ToWords } from "to-words";
import authStore from "../services/authStore";
import { jwtDecode } from "jwt-decode";

export default function CreateOrder() {
  const today = new Date().toISOString().split("T")[0];

  // const API_BASE_URL = "https://prodapi.iworkkz.com:9095";
  // const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";
  const API_BASE_URL = process.env.REACT_APP_API_URL;

  const initialFormState = {
    ReferenceNo: "",
    BookingDate: today,
    PriceValidTill: "",
    CustomerName: "",
    Address: "",
    PhoneNo: "",
    ContactPerson: "",
    Mobile: "",
    EmailId: "",
    GstNo: "",
    MachineModel: "",
    BookingAmount: 0,
    PaymentMode: "",
    PaymentReferenceNo: "",
    FreightIncluded: "YES",
  };

  const initialItemState = [
    {
      ItemCode: "",
      ItemName: "",
      Description: "",
      Qty: 1,
      Unit: "NOS",
      UnitPrice: 0,
      Amount: 0,
    },
  ];

  const getCurrentUser = () => {
    const token = authStore.getToken();

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      console.log("FULL TOKEN DATA =>", decoded);

      return Number(decoded.user_id);
    } catch (err) {
      console.error("Token decode error:", err);
      return null;
    }
  };
  const [form, setForm] = useState(initialFormState);
  const [items, setItems] = useState(initialItemState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [productList, setProductList] = useState([]);


  useEffect(() => {
    loadProducts();
  }, []);

  const loadProducts = async () => {
    try {
      const token = authStore.getToken();

      const response = await fetch(
        `${API_BASE_URL}/robotmaster/GetRobotList`,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      const result = await response.json();

      if (result.status) {
        setProductList(result.data);
      }
    } catch (error) {
      console.error("Error loading products:", error);
    }
  };

  const groupedProducts = productList.reduce((acc, item) => {
    if (!acc[item.category]) {
      acc[item.category] = [];
    }

    acc[item.category].push(item);

    return acc;
  }, {});

  const formatDate = (date) => {
    if (!date) return "";
    const [y, m, d] = date.split("-");
    return `${d}-${m}-${y}`;
  };

  const formatINR = (value) => {
    return Number(value || 0).toLocaleString("en-IN");
  };

  const GST_PERCENT = 18;

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleItemChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;

    updated[index].Amount = updated[index].Qty * updated[index].UnitPrice;

    setItems(updated);
  };

  const addItem = () => {
    setItems([
      ...items,
      {
        ItemCode: "",
        ItemName: "",
        Description: "",
        Qty: 1,
        Unit: "NOS",
        UnitPrice: 0,
        Amount: 0,
      },
    ]);
  };

  const removeItem = (index) => {
    const updated = items.filter((_, i) => i !== index);

    if (updated.length === 0) {
      updated.push(initialItemState[0]);
    }

    setItems(updated);
  };

  const total = items.reduce((s, i) => s + Number(i.Amount || 0), 0);

  const gstAmount = (total * GST_PERCENT) / 100;

  const grandTotal = total + gstAmount;

  const toWords = new ToWords({
    localeCode: "en-IN",
    converterOptions: {
      currency: true,
      ignoreDecimal: true,
      ignoreZeroCurrency: false,
    },
  });

  const amountWords = toWords.convert(grandTotal).toUpperCase();

  const generatePDF = async () => {
    const element = document.getElementById("pdfTemplate");

    const canvas = await html2canvas(element, {
      scale: 0.6,
      useCORS: true,
      allowTaint: true,
    });

    const imgData = canvas.toDataURL("image/png");

    const pdf = new jsPDF("p", "mm", "a4");

    const imgWidth = 210;
    const pageHeight = 295;

    const imgHeight = (canvas.height * imgWidth) / canvas.width;

    let heightLeft = imgHeight;
    let position = 0;

    pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;

    while (heightLeft > 0) {
      position = heightLeft - imgHeight;

      pdf.addPage();

      pdf.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);

      heightLeft -= pageHeight;
    }

    return pdf;
  };

  const createOrder = async (orderData) => {
    const token = authStore.getToken();

    console.log("TOKEN =>", token);
    console.log("CreatedBy =>", getCurrentUser());
    console.log("API URL =>", API_BASE_URL);

    const response = await fetch(`${API_BASE_URL}/orderbooking/post`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(orderData),
    });

    const data = await response.json();

    if (!response.ok) {
      console.log(data);
      throw new Error(data?.detail || "Failed to create order");
    }

    return data;
  };

  const uploadPdf = async (orderId, pdfBase64) => {
    const token = authStore.getToken();

    const response = await fetch(`${API_BASE_URL}/orderbooking/uploadpdf`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        Id: orderId,
        PdfBase64: pdfBase64,
        Createdby: getCurrentUser(),
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      console.log(data);
      throw new Error(data?.detail || "PDF upload failed");
    }
  };
  const handleSubmit = async () => {
    if (isSubmitting) return;

    if (!form.CustomerName.trim()) {
      alert("Customer Name is required");
      return;
    }

    if (!form.EmailId.trim()) {
      alert("Email Id is required");
      return;
    }

    if (!form.Address.trim()) {
      alert("Address is required");
      return;
    }

    if (!form.Mobile.trim()) {
      alert("Mobile number is required");
      return;
    }

    if (items.length === 0 || !items[0].ItemName) {
      alert("Please select Machine Model");
      return;
    }

    try {
      setIsSubmitting(true);

      const body = {
        ReferenceNo: "",

        BookingDate: form.BookingDate,

        PriceValidTill: form.PriceValidTill
          ? form.PriceValidTill
          : form.BookingDate,

        CustomerName: form.CustomerName,
        Address: form.Address,
        PhoneNo: form.PhoneNo,
        ContactPerson: form.ContactPerson,
        Mobile: form.Mobile,
        EmailId: form.EmailId,
        GstNo: form.GstNo,
        MachineModel: form.MachineModel,

        BookingAmount: parseFloat(form.BookingAmount || 0),

        TotalInr: parseFloat(total),
        GstPercent: GST_PERCENT,
        GstAmount: parseFloat(gstAmount),
        GrandTotal: parseFloat(grandTotal),

        AmountInWords: amountWords,
        PaymentMode: form.PaymentMode,
        PaymentReferenceNo: form.PaymentReferenceNo,
        FreightIncluded: "YES",

        Createdby: String(getCurrentUser()),

        LineItems: items.map((i) => ({
          ItemCode: i.ItemCode,
          ItemName: i.ItemName,
          Description: i.Description,
          Qty: Number(i.Qty),
          Unit: i.Unit,
          UnitPrice: parseFloat(i.UnitPrice),
          Amount: parseFloat(i.Amount),
        })),
      };

      const result = await createOrder(body);

      const orderId = result.Id;

      setForm((prev) => ({
        ...prev,
        ReferenceNo: orderId,
      }));

      await new Promise((resolve) => setTimeout(resolve, 500));

      const pdf = await generatePDF();

      // pdf.save(`Order_${orderId}.pdf`);
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      window.open(url);

      const pdfBase64 = pdf.output("datauristring").split(",")[1];

      await uploadPdf(orderId, pdfBase64);

      alert(`Order Created Successfully. Order ID: ${orderId}`);

      setForm({
        ...initialFormState,
        BookingDate: today,
      });

      setItems(initialItemState);
    } catch (error) {
      console.error(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // 🔹 MAIN FORM (your existing UI)
  return (
    <div className="container mt-3 compact-form">
      <h4>Book Order</h4>

      <label className="form-label small">Customer Name</label>
      <input
        name="CustomerName"
        value={form.CustomerName}
        className="form-control form-control-sm mb-2"
        onChange={handleChange}
      />

      <label className="form-label small">Address</label>
      <input
        name="Address"
        value={form.Address}
        className="form-control form-control-sm mb-2"
        onChange={handleChange}
      />

      <div className="row">
        <div className="col-md-4">
          <label className="form-label small">Phone No</label>
          <input
            name="PhoneNo"
            value={form.PhoneNo}
            className="form-control form-control-sm mb-2"
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label small">Contact Person</label>
          <input
            name="ContactPerson"
            value={form.ContactPerson}
            className="form-control form-control-sm mb-2"
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label small">Mobile</label>
          <input
            name="Mobile"
            value={form.Mobile}
            className="form-control form-control-sm mb-2"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-md-6">
          <label className="form-label small">Email Id</label>
          <input
            name="EmailId"
            value={form.EmailId}
            className="form-control form-control-sm mb-2"
            onChange={handleChange}
          />
        </div>

        <div className="col-md-6">
          <label className="form-label small">GST No</label>
          <input
            name="GstNo"
            value={form.GstNo}
            className="form-control form-control-sm mb-2"
            onChange={handleChange}
          />
        </div>
      </div>

      <h5>Items</h5>

      <table className="table table-bordered table-sm order-table">
        <thead>
          <tr>
            <th style={{ width: "40%" }}>Machine Model</th>
            <th style={{ width: "10%", textAlign: "center" }}>Qty</th>
            <th style={{ width: "20%", textAlign: "right" }}>Rate</th>
            <th style={{ width: "25%", textAlign: "right" }}>Amount (INR)</th>
            <th style={{ width: "5%" }}></th>
          </tr>
        </thead>

        <tbody>
          {items.map((i, index) => (
            <tr key={index}>
              <td>
                <select
                  className="form-control form-control-sm"
                  value={i.ItemCode}
                  onChange={(e) => {
                    const selected = productList.find(
                      (p) => p.itemno === e.target.value
                    );

                    if (selected) {
                      const updated = [...items];

                      updated[index].ItemCode = selected.itemno;
                      updated[index].ItemName = selected.robotname;

                      setItems(updated);
                    }
                  }}
                >
                  <option value="">
                    Select Machine Model
                  </option>

                  {Object.entries(groupedProducts).map(
                    ([category, products]) => (
                      <optgroup
                        key={category}
                        label={category}
                      >
                        {products.map((product) => (
                          <option
                            key={product.id}
                            value={product.itemno}
                          >
                            {product.robotname}
                          </option>
                        ))}
                      </optgroup>
                    )
                  )}
                </select>
              </td>

              <td>
                <input
                  type="number"
                  className="form-control form-control-sm qty-input"
                  value={i.Qty}
                  onChange={(e) =>
                    handleItemChange(index, "Qty", Number(e.target.value))
                  }
                />
              </td>

              <td>
                <input
                  type="text"
                  className="form-control form-control-sm rate-input"
                  value={formatINR(i.UnitPrice)}
                  onChange={(e) => {
                    const raw = e.target.value.replace(/,/g, "");
                    handleItemChange(index, "UnitPrice", Number(raw));
                  }}
                />
              </td>

              <td className="amount-cell">{formatINR(i.Amount)}</td>

              <td className="action-cell">
                <button
                  type="button"
                  className="remove-circle"
                  onClick={() => removeItem(index)}
                >
                  −
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-end">
        <button className="btn btn-secondary btn-sm mb-3" onClick={addItem}>
          Add Item
        </button>
      </div>

      <div className="text-end">
        <p>Total : ₹ {formatINR(total)}</p>
        <p>GST (18%) : ₹ {formatINR(gstAmount)}</p>
        <h6>Grand Total : ₹ {formatINR(grandTotal)}</h6>
      </div>

      <div className="row">
        <div className="col-md-4">
          <label className="form-label small">Booking Amount (INR)</label>

          <input
            type="text"
            name="BookingAmount"
            value={formatINR(form.BookingAmount)}
            className="form-control form-control-sm mb-2"
            onChange={(e) => {
              const raw = e.target.value.replace(/,/g, "");
              setForm({ ...form, BookingAmount: raw });
            }}
          />
        </div>

        <div className="col-md-4">
          <label className="form-label small">Payment Mode</label>

          <select
            name="PaymentMode"
            className="form-control form-control-sm mb-2"
            value={form.PaymentMode}
            onChange={handleChange}
          >
            <option value="">Select Payment Mode</option>
            <option value="Cash">Cash</option>
            <option value="Bank Transfer">Bank Transfer</option>
            <option value="UPI">UPI</option>
            <option value="Cheque">Cheque</option>
          </select>
        </div>
        <div className="col-md-4">
          <label className="form-label small">Reference No</label>

          <input
            type="text"
            name="PaymentReferenceNo"
            value={form.PaymentReferenceNo}
            className="form-control form-control-sm mb-3"
            onChange={handleChange}
          />
        </div>
      </div>

      <button
        className="btn btn-primary w-100"
        onClick={handleSubmit}
        disabled={isSubmitting}
      >
        {isSubmitting ? "Processing..." : "Submit Order"}
      </button>

      <div style={{ position: "absolute", left: "-9999px", top: "0" }}>
        <OrderPdfTemplate
          form={form}
          items={items}
          total={total}
          gstAmount={gstAmount}
          grandTotal={grandTotal}
          amountWords={amountWords}
        />
      </div>
    </div>
  );
}
